import { useSelector } from "react-redux";
import { LuClock3, LuChevronDown } from "react-icons/lu";

export const WEEK_DAYS = [["MONDAY", "Lunes"], ["TUESDAY", "Martes"], ["WEDNESDAY", "Miércoles"], ["THURSDAY", "Jueves"], ["FRIDAY", "Viernes"], ["SATURDAY", "Sábado"], ["SUNDAY", "Domingo"]];
const time = value => typeof value === "string" && /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/.test(value) ? value.slice(0, 5) : null;
const interval = (opening, closing) => {
  const start = time(opening), end = time(closing);
  return start && end ? `${start}–${end}${end < start ? " (día siguiente)" : ""}` : null;
};
export const dayHours = (day, continuous) => {
  if (day?.isClosed === true) return "Cerrado";
  if (!day || day.isClosed !== false) return "Sin horario publicado";
  // SplitClosingTime ends the first service; SplitOpeningTime starts the second.
  if (!continuous && (day.splitClosingTime || day.splitOpeningTime)) {
    const first = interval(day.openingTime, day.splitClosingTime);
    const second = interval(day.splitOpeningTime, day.closingTime);
    return first && second ? `${first} · ${second}` : "Sin horario publicado";
  }
  return interval(day.openingTime, day.closingTime) || "Sin horario publicado";
};
const closedDate = value => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
  return new Intl.DateTimeFormat("es-ES", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(date);
};

export const storeSchedules = (corporation, orderingSchedule) => {
  const schedules = orderingSchedule ? [orderingSchedule] : Array.isArray(corporation?.BusinessHours) ? corporation.BusinessHours.filter(schedule => corporation.onlineSalesChannel || schedule.type === "DEFAULT") : [];
  return schedules.filter(schedule => WEEK_DAYS.some(([day]) => dayHours(schedule.dayInfo?.[day], schedule.isContinuous) !== "Sin horario publicado"));
};

export const StoreHours = ({ orderingSchedule, timeZone } = {}) => {
  const corporation = useSelector(state => state.aplicationConfig.corporationData.info?.corporation);
  const hours = storeSchedules(corporation, orderingSchedule);
  const closedDays = !orderingSchedule && Array.isArray(corporation?.SpecialClosedDays) ? [...new Set(corporation.SpecialClosedDays.map(day => day.date))].sort().filter(closedDate) : [];
  if (!hours.length) return null;
  return <details className="eats-hours">
    <summary><LuClock3 aria-hidden="true" /><span>Ver horario</span><LuChevronDown aria-hidden="true" /></summary>
    <div className="eats-hours-panel">
      <h2>{orderingSchedule ? "Horario de pedidos" : "Horario general del negocio"}</h2>
      {orderingSchedule && timeZone && <p>Zona horaria: {timeZone}</p>}
      {hours.map((schedule,index) => <div key={schedule.businessHoursId || schedule.name || index}>
        {hours.length > 1 && <h3>{schedule.name}</h3>}
        <table>
          <caption className="visually-hidden">{schedule.name || "Horario semanal"}</caption>
          <thead><tr><th scope="col">Día</th><th scope="col">Horario</th></tr></thead>
          <tbody>{WEEK_DAYS.map(([day, label]) => <tr key={day}><th scope="row">{label}</th><td>{dayHours(schedule.dayInfo?.[day], schedule.isContinuous)}</td></tr>)}</tbody>
        </table>
      </div>)}
      {closedDays.length > 0 && <div className="eats-hours-exceptions"><h3>Cierres excepcionales</h3><ul>{closedDays.map(date => <li key={date}><time dateTime={date}>{closedDate(date)}</time></li>)}</ul></div>}
      {!orderingSchedule && hours.length > 0 && <p className="eats-hours-note">Horario general del negocio. La disponibilidad de pedidos online puede variar.</p>}
    </div>
  </details>;
};
